/**
 * ThemeSong for YouTube Music™ (Enhancer)
 *
 * Exposes a single web-accessible-resource entry (`/assets/*`) with no
 * `use_dynamic_url`, but scoped to `https://music.youtube.com/*` only. The bundle ships
 * just two concrete assets — icon-128.png and icon-34.png — reachable at a fixed URL,
 * but only from music.youtube.com. Anywhere else the resource does not match and a
 * negative is inconclusive.
 *
 * Manifest verified against version 1.3.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bgfiegdbajagebogifobkhambpljbfmk';

export const themesongYoutubeMusic: ExtensionDefinition = {
  id: ID,
  name: 'ThemeSong for YouTube Music™ (Enhancer)',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 50_000,
  requiredOrigin: 'https://music.youtube.com',
  notes:
    'Static assets/* WAR scoped to music.youtube.com, so only that origin can detect ' +
    'it. The bundled icon PNGs are the two concrete files exposed there.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/icon-128.png — a static icon exposed only to music.youtube.com.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/icon-128.png'),
    },
    {
      id: 'war-icon-34',
      kind: 'web-accessible-resource',
      description: 'Fetch assets/icon-34.png — the other origin-scoped icon, corroborating.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/icon-34.png'),
    },
  ],
};
